import { Text3D, Center } from "@react-three/drei";
import { animated } from "@react-spring/three";
import { useAtom } from 'jotai';
import { languageAtom } from '../GlobalState';
import translations from '../dictionaries/translations';
import DoToken from "../moveTokens/DoToken";

export default function DoAlert({ position, rotation, scale }) {
  const [language] = useAtom(languageAtom);
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";

  return (
    <animated.group position={position} rotation={rotation} scale={scale}>
      <mesh
        castShadow
        receiveShadow
        scale={[1.671, 0.065, 0.75]}
      >
        <cylinderGeometry args={[1, 1, 1, 64]}/>
        <meshStandardMaterial color='black' opacity={0.9} transparent/>
      </mesh>
      <Center position={[-0.5, 0.3, 0.1]} key={Math.random()}>
        <Text3D
          font={fontUrl}
          size={0.5}
          height={0.01}
          rotation={[Math.PI/2, Math.PI, Math.PI]}
        >
          {translations.alerts.do[language]}
          <meshStandardMaterial color="orange"/>
        </Text3D>
      </Center>
      <DoToken rotation={[0, Math.PI/2, 0]} position={[0.8, 0, 0]}/>
    </animated.group>
  )
}